import { lazy } from "react";
import type { ComponentType } from "react";

export const lazyPage = <T extends ComponentType>(
  factory: () => Promise<Record<string, T>>,
  named: string,
) => lazy(() => factory().then((module) => ({ default: module[named] as T })));
